import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_2 = { class: "-my-3.5" }
const _hoisted_3 = { class: "flex flex-wrap items-end gap-4" }

import { computed, ref } from 'vue'

import AmountField from '@/components/neue/wizard/AmountField.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { MINIMUM_OPTIONS, sectionCopy } from '@/config/fulfillmentWizardSteps'

const DEFAULT_MINIMUM_CENTS = 2500


export default {
  __name: 'StepPricing',
  setup(__props) {

const wizard = injectWizard()
const pricing = computed(() => wizard.data.pricing)

const minimumOn = ref(pricing.value.minimumOrderCents !== null)
const pickMinimum = on => {
  minimumOn.value = on
  pricing.value.minimumOrderCents = on ? pricing.value.minimumOrderCents ?? DEFAULT_MINIMUM_CENTS : null
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('fee', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AmountField, {
            modelValue: pricing.value.priceCents,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((pricing.value.priceCents) = $event)),
            kind: "money",
            name: "Amount"
          }, null, 8, ["modelValue"]),
          _createVNode(WizardButton, {
            onClick: _cache[1] || (_cache[1] = $event => (pricing.value.priceCents = 0))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Free", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-px bg-[#eef0f3]" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ToggleRow, {
            modelValue: pricing.value.taxable,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((pricing.value.taxable) = $event)),
            title: "Charge tax on this fee"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('minimum', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PillRadioGroup, {
            "model-value": minimumOn.value,
            label: "Minimum order",
            options: _unref(MINIMUM_OPTIONS),
            "onUpdate:modelValue": pickMinimum
          }, null, 8, ["model-value", "options"]),
          (minimumOn.value)
            ? (_openBlock(), _createBlock(AmountField, {
                key: 0,
                modelValue: pricing.value.minimumOrderCents,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((pricing.value.minimumOrderCents) = $event)),
                kind: "money",
                name: "Minimum"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "m-0 text-sm text-gray-600" }, " Below the minimum, checkout shows 'Add more to check out' and the customer cannot pay. ", -1))
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}